import { render, staticRenderFns } from "./StudentEcCommunications.vue?vue&type=template&id=13e4a186"
import script from "./StudentEcCommunications.vue?vue&type=script&lang=ts"
export * from "./StudentEcCommunications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports